import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

interface PageStylesProps {
  backgroundSrc: string;
}

export const PageStyles = styled(OnboardingPage)<PageStylesProps>`
  ion-content {
    background: ${({ backgroundSrc }) =>
      `url('${backgroundSrc}') center/cover no-repeat`};

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      backdrop-filter: blur(3px);
    }

    .app-logo {
      margin-bottom: 20px;
    }

    .page-title {
      margin-bottom: 20px;
    }

    .loading-wrapper {
      width: 90%;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    font-weight: 600;
  }
`;
